module.exports = __webpack_public_path__ + "static/media/ds.90e60297.svg";